export default __webpack_public_path__ + "static/media/sid.ab11f805.jpeg";